import React from 'react';
import Link from 'gatsby-link';

import Header3 from '../typographies/header3';
import Para2 from '../typographies/para2';
import Tags from './tags.js';

export default class ProjectList extends React.Component {
  renderProjects() {
    return this.props.projects.map((project, index) => {
      return (
        <Project
            key={index}
            project={project}
            color={this.props.color}
        />
      );
    });
  }
  render() {
    return (
      <div className="Projects">
        {
          this.renderProjects()
        }
      </div>
    );
  }
}

const Project = (props) => (
  <div className="row Projects-project justify-content-center">
    <div className="col-sm-12 col-md-6 Projects-project-solution-strip" style={{backgroundImage: `url(${props.project.imageUrl})`, backgroundSize: props.project.backgroundSize}}>
    </div>
    <div className={`col-sm-12 col-md-6 Projects-project-solution-detail ${props.color}`}>
      <Header3
          key="project-title"
          className="text-left"
          text={props.project.title}
      />
      <Tags
          key="project-tags"
          tags={props.project.tags}
      />
      <Para2
          key="project-subtitle"
          className="text-left grey"
          text={props.project.subtitle}
      />
      <Link to={props.project.link} className={`button Projects-project-solution-detail-button ${props.color}`}>
        {props.project.actionText}
      </Link>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/list/projectList.js